import { get } from 'svelte/store';
import { user_data, home_data } from 'src/stores/account/user';

/**
 * Checks if the energy price feature (Verivox integration) is enabled for the current user.
 *
 * This function determines access based on:
 * - User type (excludes installers)
 * - Backend flag: de_users parameter in home_data store
 *
 * @returns {boolean} true if the feature should be enabled, false otherwise
 */
export const isEnergyPriceFeatureEnabled = (): boolean => {
	const userData = get(user_data);
	const homeData = get(home_data);

	// Exclude installers
	if (userData?.installer) {
		return false;
	}

	// Check backend flag: de_users parameter in home_data
	// This parameter is present for accounts that have access to the feature
	if (!homeData?.de_users) {
		return false;
	}

	return true;
};
